<script lang="ts">
  import { onMount } from "svelte";
  import { Table } from "../../components/Table";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { init, loading, request, response, search, clearRequest } from "./traceability.store";
  import { traceabilityInfoDtoFields, traceabilityInfoSlaughterDtoFields } from "../../utils/TableFields/traceability-info-dto.fields";
  import Button from "../../components/Button.svelte";
  import Icon from "../../components/Icon.svelte";
  import Input from "../../components/Form/Fields/Input.svelte";

  onMount(init);
</script>

<MainLayout>
  <nav class="level">
    <div class="level-left">
      <div class="level-item">
        <div class="field has-addons">
          <p class="control has-icons-right">
            <Input name="" placeholder="lotto" bind:value={$request.referenceValue} on:enter={search} />

            <span class="icon is-small is-right">
              <i class="delete" on:click={clearRequest} />
            </span>
          </p>

          <p class="control">
            <Button on:click={search}>
              <Icon name="search" />
              <span> Cerca </span>
            </Button>
          </p>
        </div>
      </div>

      <div class="level-item">
        <!-- may use on:change={search} -->
        <select class="traceability-type-selector" bind:value={$request.referenceType}>
          <option value="slaughter" selected>Lotto macellazione</option>
          <option value="section" selected>Lotto sezionamento</option>
          <option value="transform" selected>Lotto trasformazione</option>
          <!--
          <option value="ingredient" selected>Lotto ingrediente</option>
          <option value="material" selected>Lotto materiale</option>
          -->
        </select>
      </div>
    </div>
  </nav>

  {#if $response}
    <h2 class="subtitle has-text-weight-bold">Macellazione</h2>
    <Table loading={$loading} fields={traceabilityInfoSlaughterDtoFields} records={$response.slaughters} />

    <h2 class="subtitle has-text-weight-bold">Sezionamento</h2>
    <Table loading={$loading} fields={traceabilityInfoDtoFields} records={$response.sections} />

    <h2 class="subtitle has-text-weight-bold">Trasformazione salumi</h2>
    <Table loading={$loading} fields={traceabilityInfoDtoFields} records={$response.transforms} />

    <h2 class="subtitle has-text-weight-bold">Ingredienti</h2>
    <Table loading={$loading} fields={traceabilityInfoDtoFields} records={$response.ingredients} />

    <h2 class="subtitle has-text-weight-bold">Materiali</h2>
    <Table loading={$loading} fields={traceabilityInfoDtoFields} records={$response.materials} />
  {:else}
    <p>Effettua una ricerca per lotto e tipologia per visualizzare i dati di tracciatura.</p>
  {/if}
</MainLayout>

<style>
  .traceability-type-selector {
    height: 32px;
    width: 100%;
    display: inline-flex;
  }
</style>
